import React from 'react'
import { FormattedMessage } from 'react-intl'
import * as PropTypes from 'prop-types'

function DynamicFormattedMessage (props) {
  return <FormattedMessage {...props} />
}

DynamicFormattedMessage.propTypes = {
  id: PropTypes.string.isRequired,
  defaultMessage: PropTypes.string
}

export default DynamicFormattedMessage
